<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <!-- 产品名 -->
          <el-form-item label="产品名：" class="form-item-b0">
            <!-- <el-input
              v-model="query.search"
              placeholder="请输入产品名"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input> -->
            <el-select v-model="query.search" allow-create filterable placeholder="请选择产品名">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 类名 -->
          <el-form-item label="类名：" class="form-item-b0">
            <!-- <el-input
              v-model="query.category"
              placeholder="请输入产品类名"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input> -->
            <el-select
              popper-class="data-list"
              allow-create
              v-model="query.category"
              filterable
              placeholder="请选择类名"
              @change="dataChange"
            >
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 烟酒选择 -->
          <el-form-item label="烟酒：" class="form-item-b0">
            <el-select v-model="query.category1" placeholder="请选择分类">
              <el-option label="烟盒" value="全部"></el-option>
              <el-option label="国酒" value="国酒"></el-option>
              <el-option label="洋酒" value="洋酒"></el-option>
            </el-select>
          </el-form-item>
          <!-- 条码选择 -->
          <el-form-item label="条码：" class="form-item-b0">
            <el-select v-model="query.isCode" placeholder="是否有条码">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <!-- 盒码选择 -->
          <el-form-item label="盒码：" class="form-item-b0">
            <el-select v-model="query.isBoxCode" placeholder="是否有盒码">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>
          <el-button size="small" @click="init()">重置</el-button>
          <el-button type="success" size="mini" @click="onEditInfo({}, 1)">添加产品</el-button>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column prop="Id" label="产品Id" align="center"></el-table-column>
      <el-table-column prop="Category2" label="类目" align="center"></el-table-column>
      <el-table-column prop="Name" label="产品名称" align="center"></el-table-column>
      <el-table-column prop="Code" label="条形码1" align="center"></el-table-column>
      <el-table-column prop="BoxCode" label="小盒条码" align="center"></el-table-column>
      <el-table-column prop="Price" label="价格" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.LSPrice">流沙:{{ scope.row.LSPrice || '' }}</div>
          <div v-if="scope.row.ZSJPrice">珠三角:{{ scope.row.ZSJPrice || '' }}</div>
          <div v-if="scope.row.SZPrice">深圳A:{{ scope.row.SZPrice || '' }}</div>
          <div v-if="scope.row.SZPrice2">深圳B:{{ scope.row.SZPrice2 || '' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Image" label="产品图片" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 60px; height: 60px; margin-top: 6px"
            :src="scope.row.Image"
            fit="contain"
            :preview-src-list="[scope.row.Image]"
          ></el-image>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="Integral" label="商铺类型" align="center">
        <template slot-scope="scope">
          <template>
            <span>{{ scope.row.StoreType }}</span>
          </template>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onEditInfo(scope.row, 0)"> 修改信息 </el-button>
          <!-- <el-button style="margin-top:10px;margin-left: 0;" type="success" size="mini" @click="onEditInfo(scope.row, 1)">
            添加信息
          </el-button> -->
          <el-button
            style="margin-top: 10px; margin-left: 0"
            type="danger"
            size="mini"
            @click="onEditInfo(scope.row, 2)"
          >
            删除信息
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 商户管理 -->
    <el-dialog
      :visible.sync="editPhoneDialog"
      class="FormDialogBox"
      width="680px"
      title="添加图片"
      :close-on-click-modal="false"
      append-to-body
      @close="editPhoneCancel()"
    >
      <el-form label-width="auto" :model="editForm" ref="ruleForm">
        <div style="display: flex">
          <el-form-item label="分类">
            <!-- <el-input v-model="editForm.Category1" placeholder="产品类目"></el-input> -->
            <el-select v-model="editForm.Category1" placeholder="请选择分类">
              <el-option label="烟盒" value="全部"></el-option>
              <el-option label="国酒" value="国酒"></el-option>
              <el-option label="洋酒" value="洋酒"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="类目">
            <el-input v-model="editForm.Category2" placeholder="产品类目"></el-input>
          </el-form-item>

          <el-form-item label="名称">
            <el-input v-model="editForm.Name" placeholder="产品名称"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="烟厂">
            <el-input v-model="editForm.Factory" placeholder="Factory"></el-input>
          </el-form-item>

          <el-form-item label="代码">
            <el-input v-model="editForm.FactoryCode" placeholder="FactoryCode"></el-input>
          </el-form-item>

          <el-form-item label="公司价">
            <el-input v-model="editForm.OutPrice" placeholder="OutPrice"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="条码1">
            <el-input v-model="editForm.Code" placeholder="Code"></el-input>
          </el-form-item>

          <el-form-item label="条码2">
            <el-input v-model="editForm.Code2" placeholder="Code2"></el-input>
          </el-form-item>

          <el-form-item label="小盒码">
            <el-input v-model="editForm.BoxCode" placeholder="BoxCode"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="爆珠">
            <el-input v-model="editForm.Bead" placeholder="Bead"></el-input>
          </el-form-item>

          <el-form-item label="规格">
            <el-input v-model="editForm.Spec" placeholder="Spec"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="流沙排序">
            <el-input v-model="editForm.Sort" placeholder="Sort"></el-input>
          </el-form-item>

          <el-form-item label="行">
            <el-input v-model="editForm.Order" placeholder="Order"></el-input>
          </el-form-item>

          <el-form-item label="列">
            <el-input v-model="editForm.Column" placeholder="Column"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="珠三角排序">
            <el-input v-model="editForm.ZSJSort" placeholder="Sort"></el-input>
          </el-form-item>

          <el-form-item label="行">
            <el-input v-model="editForm.Order2" placeholder="Order2"></el-input>
          </el-form-item>

          <el-form-item label="列">
            <el-input v-model="editForm.Column2" placeholder="Column2"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="深圳A排序">
            <el-input v-model="editForm.SZSort" placeholder="Sort"></el-input>
          </el-form-item>

          <el-form-item label="行">
            <el-input v-model="editForm.Order3" placeholder="Order3"></el-input>
          </el-form-item>

          <el-form-item label="列">
            <el-input v-model="editForm.Column3" placeholder="Column3"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="深圳B排序">
            <el-input v-model="editForm.SZSort2" placeholder="Sort"></el-input>
          </el-form-item>

          <el-form-item label="行">
            <el-input v-model="editForm.Order4" placeholder="Order4"></el-input>
          </el-form-item>

          <el-form-item label="列">
            <el-input v-model="editForm.Column4" placeholder="Column4"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="流沙B排序">
            <el-input v-model="editForm.Sort" placeholder="Sort"></el-input>
          </el-form-item>

          <el-form-item label="行">
            <el-input v-model="editForm.Order5" placeholder="Order5"></el-input>
          </el-form-item>

          <el-form-item label="列">
            <el-input v-model="editForm.Column5" placeholder="Column5"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex">
          <el-form-item label="湖南排序">
            <el-input v-model="editForm.HNSort" placeholder="Sort"></el-input>
          </el-form-item>

          <el-form-item label="行">
            <el-input v-model="editForm.Order6" placeholder="Order6"></el-input>
          </el-form-item>

          <el-form-item label="列">
            <el-input v-model="editForm.Column6" placeholder="Column6"></el-input>
          </el-form-item>
        </div>

        <!-- <el-form-item label="流沙价">
          <el-input v-model="editForm.LSPrice" placeholder="LSPrice"></el-input>
        </el-form-item>
        <el-form-item label="珠三角价">
          <el-input v-model="editForm.ZSJPrice" placeholder="ZSJPrice"></el-input>
        </el-form-item>
         <el-form-item label="深圳价">
          <el-input v-model="editForm.SZPrice" placeholder="SZPrice"></el-input>
        </el-form-item> -->

        <el-form-item label="传播图片">
          <el-upload
            ref="upload"
            action="https://api.chajiuqu.com/api/current/uploadimage"
            list-type="picture-card"
            :file-list="myImage1"
            :limit="1"
            :on-preview="handlePictureCardPreview"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="多图添加">
          <el-upload
            ref="upload2"
            action="https://api.chajiuqu.com/api/current/uploadimage"
            list-type="picture-card"
            :file-list="myImage"
            multiple
            :limit="9"
            :on-preview="handlePictureCardPreview2"
            :on-remove="handleRemove2"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editPhoneDialog = false">取 消</el-button>
        <el-button :type="editForm.type == 2 ? 'danger' : 'primary'" @click="editPhoneDetermine()">
          {{ editForm.type == 2 ? '确定删除' : '确 定' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" fullscreen top="0vh">
      <el-image style="width: 20%; display: block; margin: 0 auto;" :src="dialogImageUrl"></el-image>
    </el-dialog> -->

    <div class="pre_img" v-if="dialogVisible">
      <i class="el-icon-circle-close icon" @click="imgClose"></i>
      <el-image class="img" style="width: 20%; display: block; margin: 0 auto" :src="dialogImageUrl"></el-image>
    </div>
  </div>
</template>

<script>
import regionArr from '@/utils/citys.json'
import dataArr from '@/utils/data1.json'
import dataAllArr from '@/utils/data.json'
const dataAllList = []
for (const key in dataAllArr) {
  dataAllList.push(...dataAllArr[key])
}

export default {
  name: 'membersIndex',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      imageUrl: '',
      multipleImg: [],
      list: [],
      loading: true,
      query: {
        pageindex: 1,
        pagesize: 20,
        search: '',
        category: '',
        isBoxCode: null,
        isCode: null
      },
      category1: '香烟', // 烟酒选择
      total: 0, // 总条数
      // 修改手机号
      editPhoneDialog: false,
      editForm: {},
      // 省市区
      region: null,
      regionOptions: regionArr,

      options: dataArr.data,
      value: '',
      options2: dataAllList,
      value2: ''
    }
  },
  created() {
    this.getList('place')
    // this.addProduct()
  },
  computed: {
    myImage: function () {
      const arr = []
      if (this.editForm.DetailImage) {
        const list = this.editForm.DetailImage.split(',')
        list.forEach((item) => {
          if (item) {
            arr.push({
              url: item
            })
          }
        })
      }
      return arr
    },
    myImage1: function () {
      const arr = []
      if (this.editForm.Image) {
        arr.push({
          url: this.editForm.Image
        })
      }
      return arr
    }
  },
  methods: {
    // 初始化
    init() {
      this.query.search = ''
      this.query.category = ''
      this.query.category1 = ''

      this.getList('place')
    },

    dataChange(e) {
      // console.log(e)
      this.query.search = ''
      if (e && e !== '全部') {
        this.options2 = dataAllArr[e]
      } else if (e === '全部') {
        this.options2 = dataAllList
      }
    },

    beforeAvatarUpload(file) {
      const _this = this
      let imgWidth = ''
      let imgHight = ''
      const isSize = new Promise(function (resolve, reject) {
        const width = 375
        const height = 280
        const _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = function () {
          imgWidth = img.width
          imgHight = img.height
          const valid = img.width === width && img.height === height
          // eslint-disable-next-line prefer-promise-reject-errors
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return file
        },
        () => {
          _this.$message.warning({
            message:
              '上传文件的图片大小不合符标准,宽需要为375px，高需要为280px。当前上传图片的宽高分别为：' +
              imgWidth +
              'px和' +
              imgHight +
              'px',
            btn: false
          })
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject()
        }
      )
      console.log(isSize)
      return isSize
    },
    handleAvatarSuccess(res, file) {
      console.log(res)
      console.log(file)
      if (res.success) {
        this.imageUrl = res.data
        console.log(this.imageUrl)
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      console.log(file.url)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    handleRemove2(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview2(file) {
      console.log(file.url)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    imgClose() {
      this.dialogImageUrl = ''
      this.dialogVisible = false
    },

    // 获取列表
    async getList(place) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        this.$nextTick(() => {
          this.$refs.TableListRef.bodyWrapper.scrollTop = 0
        })
      }

      if (this.query.category === '全部') {
        this.query.category = ''
      }

      // const { data: res } = await this.$api.members.getStoreList(this.query)
      // console.log('获取商户审核列表', res)

      console.log(this.query)

      const { data: res } = await this.$api.product.getList(this.query)
      console.log('获取产品列表', res)

      this.loading = false
      this.list = res.list
      this.total = res.count
    },
    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },

    // 修改产品信息
    onEditInfo(item, type) {
      if (type === 1) {
        this.editForm.type = type
        this.editForm = {
          ...this.editForm
        }
        console.log('this.editForm', this.editForm)
        this.editPhoneDialog = true
        return
      }
      const form = this.$globalFun.deepClone(item)
      this.editForm = form
      this.editForm.type = type
      this.editForm = {
        ...this.editForm
      }
      console.log('this.editForm', this.editForm)
      this.editPhoneDialog = true
    },
    editPhoneCancel() {
      // console.log('对话框关闭')
      this.editForm = {}
      this.$refs.upload.clearFiles()
    },
    async addProduct(i = 0) {
      const str =
        '四川,长城(牛年生肖版) 木盒10|四川,长城(虎年生肖版) 木盒10|四川,长城(兔年生肖版)(拆封) 木盒10|四川,长城(兔年生肖版)(原封) 木盒10|四川,长城(兔年生肖限量版)(拆封) 木盒10|四川,长城(132益川老坊) 木盒25|四川,长城(132益川老坊)云南地限 木盒25|四川,长城(10支132秘制) 木盒10|四川,长城(5支传奇1号) 木盒5|四川,长城(5支传奇3号) 木盒5|四川,长城(2号) 纸盒5|四川,长城(揽胜3号经典) 木盒10|四川,长城(经典2号) 木盒5|四川,长城(经典2号新版) 木盒5|四川,长城(经典3号) 木盒5|四川,长城(经典3号新版) 木盒10|四川,长城(3号) 纸盒5|四川,长城(大号铝管5支) 木盒5|四川,长城(红色132) 铁盒5|四川,长城(盛世3号) 纸盒10|四川,长城(盛世5号) 纸盒10|四川,长城(盛世6号) 纸盒30|四川,长城(GL1号)(不烫码) 木盒5|四川,长城(GJ6) 木盒10|四川,长城(GJ6成都限量) 木盒10|四川,长城(国礼3) 木盒10|四川,长城(国礼3)成都限量版 木盒10|四川,长城(伟大的胜利) 木盒10|四川,长城(唯佳金字塔) 木盒10|四川,长城(唯佳金字塔)成都限量 木盒10|四川,狮牌(加勒比阳光) 纸盒20|四川,长城(骑士壹号) 纸盒20|四川,长城(骑士三号) 纸盒20|四川,长城(深圳40周年)盛世奇迹 木盒5|四川,长城(132记忆) 纸盒25|四川,长城(132奇迹) 纸盒10|四川,长城(132奇迹成都限量) 纸盒10|四川,长城(国之韵2号) 纸盒200|四川,长城(毛氏8号) 纸盒2|四川,长城(毛氏13号) 木盒200|四川,长城(迷你香草) 铁盒100|四川,长城(迷你咖啡) 铁盒100|四川,长城(迷你原味 铁盒100|四川,长城(醇味132) 纸盒100|四川,长城(醇雅coco) 纸盒200|四川,长城(醇雅奶香) 纸盒200|四川,狮牌(迷你小雪茄) 纸盒50|四川,长城(迷你2号) 纸盒50|四川,长城(迷你3号) 纸盒50|四川,长城(金南极) 纸盒50|山东,泰山(巅峰2号) 木盒10|山东,泰山(巅峰5号) 木盒10|山东,泰山(巅峰6号) 纸盒5|山东,将军(战神1号) 木盒10|山东,将军(大力袖 纸盒5|山东,将军(战神3号) 木盒10|山东,将军(战神5号) 纸盒8|山东,泰山(超级战神) 木盒10|山东,将军(战神6H) 纸盒5|山东,将军(战神07) 铁盒50|山东,将军(战神荣耀) 纸盒50|山东,将军(战神4号) 铁盒4|山东,将军(3G) 铁盒100|山东,泰山(3G咖啡) 纸盒100|山东,泰山(3G水蜜桃) 纸盒100|山东,泰山(3G沉香) 铁盒80|山东,泰山(巴哈马) 纸盒100|山东,泰山(巴哈马甜味) 铁盒100|山东,泰山(黑豹) 纸盒200|山东,泰山(雪豹) 纸盒200|山东,泰山(雪豹中支) 纸盒200|山东,泰山(丛林都市) 木盒10|安徽,王冠(智者010五支) 竹盒5|安徽,王冠(智者010十支) 竹盒  10|安徽,王冠(大国粹) 木盒  10|安徽,王冠(满堂彩) 木盒5|安徽,王冠(假日 · 阳光) 纸盒   4|安徽,王冠(梅兰竹菊) 纸盒8|安徽,王冠(茶香之茶马古道) 纸盒10|安徽,王冠(国粹风度) 木盒10|安徽,王冠(古建三绝 纸盒10|安徽,王冠(10支全叶卷) 木盒10|安徽,王冠(蓝色假日) 纸盒25|安徽,王冠(小国粹 纸盒25|安徽,王冠(经典铝2支全叶卷) 纸盒10|安徽,王冠(塑2支全叶卷) 纸盒10|安徽,王冠(经典5号) 纸盒5|安徽,王冠(经典8号) 纸盒10|安徽,王冠(假日 ·黄金海岸) 纸盒D100=1|安徽,王冠(赛悦) 铁盒100|安徽,王冠(塑) 塑盒10|安徽,王冠(奶香) 铁盒100|安徽,王冠(原味1号) 纸盒10|安徽,王冠(原味2号) 塑盒10|安徽,王冠(原味9号) 纸盒50|安徽,王冠(原味9号塑) 纸盒100|安徽,王冠(20支) 纸盒200|安徽,王冠(国粹名角) 纸盒100|安徽,王冠(粗万象) 纸盒200|安徽,王冠(MIX香草) 铁盒50|安徽,王冠(原味3号) 铁盒50|安徽,王冠(原味3号) 纸盒50|湖北,黄鹤楼(公爵) 铝盒10|湖北,黄鹤楼(1916雪之梦2号) 木盒1|湖北,黄鹤楼(1916雪之梦3号) 木盒10|湖北,黄鹤楼(雪之梦6号) 纸盒10|湖北,黄鹤楼(雪之梦5号) 木盒10|湖北,黄鹤楼(雪之梦7号) 纸盒25|湖北,黄鹤楼(雪之梦8号) 纸盒5|湖北,黄鹤楼(雪之梦9号) 纸盒25|湖北,黄鹤楼(雪之梦10号) 纸盒24|湖北,黄鹤楼(逍遥3号) 木盒10|湖北,黄鹤楼(逍遥5号) 木盒10|湖北,黄鹤楼(逍遥6号) 木盒10|湖北,黄鹤楼(雪之韵2号) 硬盒20|湖北,黄鹤楼(雪之韵5号) 纸盒300|湖北,黄鹤楼(雪之韵6号) 纸盒100|湖北,undefined undefined  机制雪|湖北,黄鹤楼(雪之景2号) 纸盒120|湖北,黄鹤楼(雪之景3号) 纸盒100|湖北,黄鹤楼(雪之景5号) 纸盒100|湖北,黄鹤楼(雪之景6号) 纸盒100|湖北,黄鹤楼(雪之景7号) 纸盒200|湖北,黄鹤楼(雪之景9号) 纸盒100|湖北,黄鹤楼(雪之景10号) 纸盒100|湖北,黄鹤楼(迷你醇味) 铁盒100|湖北,黄鹤楼(冰爽) 纸盒100|湖北,茂大(1号) 纸盒20|湖北,工字牌(小雪茄) 纸盒200'
      const strArr = str.split('|')

      const arr = strArr[i].split(',')
      const name = arr[1]
      const factory = arr[0]
      const form = {
        id: 0,
        name,
        category1: '香烟',
        category2: '国产雪茄',
        factory,
        outPrice: 0,
        spec: '雪茄'
      }

      console.log(name, i, strArr[i], form)

      if (i < strArr.length) {
        // const { data: res } = await this.$api.product.add(form)
        // console.log(res)

        this.addProduct(i + 1)
      }
    },
    async editPhoneDetermine() {
      console.log('this.editForm1', this.editForm)
      const type = this.editForm.type

      let imgUrls = ''
      this.$refs.upload2.uploadFiles.forEach((item) => {
        if (item.percentage === 100) {
          console.log(item.response.data)
          imgUrls += item.response.data + ','
        } else if (!item.percentage) {
          imgUrls += item.url + ','
        }
      })
      imgUrls = imgUrls.substr(0, imgUrls.length - 1)
      console.log('imgUrls', imgUrls, this.$refs.upload2.uploadFiles)

      const form = {
        id: this.editForm.Id,
        name: this.editForm.Name,
        category1: this.editForm.Category1,
        category2: this.editForm.Category2,
        code: this.editForm.Code,
        code2: this.editForm.Code2,
        boxcode: this.editForm.BoxCode,
        sort: this.editForm.Sort,
        zsjsort: this.editForm.ZSJSort,
        szsort: this.editForm.SZSort,
        szsort2: this.editForm.SZSort2,
        image: this.imageUrl,
        detailImage: imgUrls,
        order: this.editForm.Order || 0,
        order2: this.editForm.Order2 || 0,
        order3: this.editForm.Order3 || 0,
        order4: this.editForm.Order4 || 0,
        order5: this.editForm.Order5 || 0,
        order6: this.editForm.Order6 || 0,
        column: this.editForm.Column || 0,
        column2: this.editForm.Column2 || 0,
        column3: this.editForm.Column3 || 0,
        column4: this.editForm.Column4 || 0,
        column5: this.editForm.Column5 || 0,
        column6: this.editForm.Column6 || 0,
        factory: this.editForm.Factory,
        factoryCode: this.editForm.FactoryCode,
        outPrice: this.editForm.OutPrice || 0,
        spec: this.editForm.Spec,
        bead: this.editForm.Bead
        // lsprice: this.editForm.LSPrice - 0 || null,
        // zsjPrice: this.editForm.ZSJPrice - 0 || null,
        // szPrice: this.editForm.SZPrice - 0 || null
      }
      if (type === 0) {
        if (form.image.length < 1) {
          form.image = this.editForm.Image
        }
        console.log('form', form)

        const { data: res } = await this.$api.product.addImage(form)
        console.log('修改结果', res)
      } else if (type === 2) {
        const { data: res } = await this.$api.product.del({ id: form.id })
        console.log('删除结果', res)
      } else {
        if (!form.name) {
          this.$message.success('请填入信息')
          return
        }
        console.log('form', form)
        const { data: res } = await this.$api.product.add(form)
        console.log('添加结果', res)
      }

      this.$message.success('修改成功')
      this.getList()
      this.imageUrl = ''
      this.editPhoneDialog = false
      this.$refs.upload.clearFiles()
      this.$refs.upload2.clearFiles()
    },

    // 判断是否过期
    ifOverdue(time) {
      // console.log('time', time)
      const nowDate = new Date()
      const date = new Date(time).getTime() - nowDate.getTime()

      return date < 0
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .data-list {
  width: 620px !important;

  ul.el-scrollbar__view {
    display: flex;
    flex-wrap: wrap;
  }
}

.auditImg {
  display: flex;
  .block {
    margin-right: 25px;
    span {
      display: block;
      width: 120px;
      text-align: center;
    }
    img {
      width: 120px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.pre_img {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999988;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 60px;
    top: 60px;
    font-size: 40px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
  }

  .img {
    width: 20%;
    display: block;
  }
}
</style>
